export default function getExt(filename = '') {
  const list = filename.split('.');
  if (list.length < 2) {
    return '';
  }
  return list.pop();
}